import { defineMessages } from 'react-intl-next';

export default defineMessages({
	success: {
		id: 'ai-mate.loading-status-indicator.success',
		defaultMessage: 'Success',
		description: 'Status label - success',
	},
	loading: {
		id: 'ai-mate.loading-status-indicator.loading',
		defaultMessage: 'Loading',
		description: 'Status label - loading',
	},
	error: {
		id: 'ai-mate.loading-status-indicator.error',
		defaultMessage: 'Error',
		description: 'Status label - error',
	},
	info: {
		id: 'ai-mate.loading-status-indicator.info',
		defaultMessage: 'Information',
		description: 'Status label - info',
	},
	warning: {
		id: 'ai-mate.loading-status-indicator.warning',
		defaultMessage: 'Warning',
		description: 'Status label - warning',
	},
	discovery: {
		id: 'ai-mate.loading-status-indicator.discovery',
		defaultMessage: 'Discovery',
		description: 'Status label - discovery',
	},
	todo: {
		id: 'ai-mate.loading-status-indicator.todo',
		defaultMessage: 'To do',
		description: 'Status label - todo',
	},
});
